export default __webpack_public_path__ + "static/media/hallmark-orange-crown.bc3182a4.svg";